/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


require("@rails/ujs").start()
// require("turbolinks").start()
// require("channels")
// require("@rails/activestorage").start()


//require("@rails/actiontext")
const $ = require("jquery")
global.$ = $
global.jQuery = $
require('popper.js')

import "trix"
import "@rails/actiontext"

import 'css/site'
import "controllers" 

import '../src/font-awesome.js'
import '../src/puntkomma.js'
import '../src/uren_reservering.js'

